import React from 'react';
import { Linkedin, Instagram } from 'lucide-react';

const SOCIALS = [
  {
    key: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/vidat-instituto-de-inteligencia-m%C3%A9dica',
    Icon: Linkedin,
  },
  {
    key: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/vidat.instituto.medico',
    Icon: Instagram,
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    href: 'https://www.tiktok.com/@vidat.instituto.medico',
    Icon: ({ size = 18, strokeWidth = 1.5, ...rest }) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...rest}
      >
        <path d="M21 8.5a7.5 7.5 0 0 1-5.2-2V15.5a5.5 5.5 0 1 1-5.5-5.5h.7v3.2h-.7a2.3 2.3 0 1 0 2.3 2.3V2h3.2a4.3 4.3 0 0 0 5.2 4.3v2.2z" />
      </svg>
    ),
  },
];

const SocialLinks = ({ variant = 'dark', size = 18, className = '', testIdPrefix = 'social' }) => {
  const isDark = variant === 'dark';
  const baseColor = isDark ? 'text-white/70' : 'text-stone-500';
  const hoverColor = isDark ? 'hover:text-white' : 'hover:text-cyan-vidat';

  return (
    <ul
      className={`flex items-center gap-5 ${className}`}
      data-testid={`${testIdPrefix}-links`}
    >
      {SOCIALS.map(({ key, label, href, Icon }) => (
        <li key={key}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={`${testIdPrefix}-${key}`}
            className={`inline-flex items-center justify-center transition-colors ${baseColor} ${hoverColor}`}
          >
            <Icon size={size} strokeWidth={1.5} />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
